import { makeStyles } from '@material-ui/core';

import { DEFAULT_FONT_FAMILY } from '../../constants';

const useStyles = makeStyles(() => ({
  title: {
    color: 'white',
    fontFamily: DEFAULT_FONT_FAMILY,
  },
  wrapperHeaderItems: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '16px',
    alignItems: 'flex-end',
  },
  dateAndStatus: {
    display: 'flex',
  },
  wrapperStatusByItems: {
    alignSelf: 'end',
    marginLeft: '16px',
    borderRadius: '6px',
    display: 'flex',
    marginBottom: '16px',
  },
  wrapperSearchField: {
    marginBottom: '16px',
    border: '1px solid #1D2035',
    borderRadius: '12px',
  },
  wrapperSearchFieldMobile: {
    margin: '0px 0px 16px 16px',
  },
  btnClose: {
    position: 'relative',
    marginLeft: '-32px',
    cursor: 'pointer',
  },
  formControl: {
    minWidth: '66px',
    marginBottom: '2px',
  },
  initialSelect: {
    color: '#3BB0FF',
    padding: '7px 12px',
    background: '#1D3960',
    borderRadius: '32px',
    border: '1px solid #3BB0FF26',
    fontFamily: DEFAULT_FONT_FAMILY,

    '&:focus': {
      background: '#1D3960',
      borderRadius: '32px',
      border: '1px solid #3BB0FF26',
    },
  },
  activeSelect: {
    color: '#3BB0FF',
    padding: '7px 12px',
    background: '#1D3960',
    borderRadius: '32px',
    fontFamily: DEFAULT_FONT_FAMILY,
    border: '1px solid #3BB0FF26',

    '&:focus': {
      background: '#1D3960',
      borderRadius: '32px',
      color: '#3BB0FF',
    },
  },
  menuItemRoot: {
    height: '56px',
    fontSize: '16px',
    fontFamily: DEFAULT_FONT_FAMILY,

    '&:first-child': {
      display: 'none',
    },

    '&:hover': {
      opacity: 1,
    },
  },
  selected: {
    color: '#2D2D2D',
    background: '#F6F6F8 !important',
    fontFamily: DEFAULT_FONT_FAMILY,
    fontSize: '16px',
  },
  initialText: {
    marginRight: '-12px',
    paddingTop: '1px',
  },
  selectedText: {
    marginRight: '16px',
    paddingTop: '1px',
  },
}));

export { useStyles };
